import './nazarethhall/style';
import FormStructure from './nazarethhall/form_structure';

export default FormStructure;